import { useState, useEffect } from "react";

const sassVariables = {
  tablet: 768,
  desktop: 1024,
};

export const MEDIA_QUERIES = {
  tabletOnly: "(min-width: " + (sassVariables.tablet - 1) + "px and (max-width:" + (sassVariables.desktop - 1) + "px)",
  untilTablet: `(max-width: ${sassVariables.tablet - 1}px)`,
  untilDesktopAndDesktop: `(max-width: ${sassVariables.desktop}px)`,
  canHover: "(hover: hover) and (pointer: fine)",
  standAlone: "(display-mode: standalone), (display-mode: minimal-ui)",
};

const isApiSupported = (api) => (typeof window !== "undefined" ? api in window : false);
const isClient = typeof window === "object";

const useMediaQuery = (mediaQuery) => {
  let canMatchMedia = true;
  if (!isClient || !isApiSupported("matchMedia")) {
    // eslint-disable-next-line no-console
    canMatchMedia = false;
  }

  const [isVerified, setIsVerified] = useState(
    canMatchMedia ? !!window.matchMedia(mediaQuery).matches : null
  );

  useEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQuery);
    const documentChangeHandler = () => setIsVerified(!!mediaQueryList.matches);

    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", documentChangeHandler);
    } else if (mediaQueryList.addListener) {
      mediaQueryList.addListener(documentChangeHandler);
    }

    documentChangeHandler();
    return () => {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener("change", documentChangeHandler);
      } else if (mediaQueryList.removeListener) {
        mediaQueryList.removeListener(documentChangeHandler);
      }
    };
  }, [mediaQuery]);

  return isVerified;
};

export default useMediaQuery;
